export default __webpack_public_path__ + "static/media/electronics.6a633536.jpg";